import React, { FC, useContext } from 'react';

import { Badge } from '@epoch-ui/components/Badge';
import { GuestStatus } from 'types/guest.types';

import { RSVPControlModalContext } from '../rsvpControlContext';
import { useGuestSideSheetContext } from '../../../guestSideSheetContext';

interface PlusOneStatusNoticeProps {
  selectedStatus?: GuestStatus | null;
}

export const PlusOneStatusNotice: FC<PlusOneStatusNoticeProps> = (props) => {
  const {
    guestData: { guest }
  } = useGuestSideSheetContext();
  const context = useContext(RSVPControlModalContext);

  const selectedStatus =
    props.selectedStatus !== undefined ? props.selectedStatus : context?.selectedStatus;

  if (!guest) {
    return null;
  }

  const isCurrentStatusGoingOrWaitlisted =
    guest.status === GuestStatus.CONFIRMED ||
    guest.status === GuestStatus.CONFIRMED_WITH_INCOMPLETE_SURVEY ||
    guest.status === GuestStatus.WAITLISTED;

  const isTargetStatusWaitlisted = selectedStatus === GuestStatus.WAITLISTED;
  const isTargetStatusGoing =
    selectedStatus === GuestStatus.CONFIRMED ||
    selectedStatus === GuestStatus.CONFIRMED_WITH_INCOMPLETE_SURVEY;

  const plusOnes = guest.plusOnes || [];

  const shouldShowNotice =
    plusOnes.length > 0 &&
    selectedStatus &&
    isCurrentStatusGoingOrWaitlisted &&
    !isTargetStatusGoing;

  if (!shouldShowNotice) {
    return null;
  }

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <span className="tw-text-sm tw-leading-5 tw-text-black">
        {guest.firstName} has guests for this event.{' '}
        {isTargetStatusWaitlisted
          ? 'Their RSVP status will be updated to waitlisted.'
          : "They'll be removed from this event."}
      </span>
      <div className="tw-flex tw-flex-col tw-rounded-3xl tw-border tw-border-solid tw-border-border-grey">
        {plusOnes.map((plusOne, index) => (
          <div
            key={plusOne.plusOneId}
            className="tw-flex tw-items-center tw-justify-between tw-border-b  tw-border-l-0 tw-border-r-0 tw-border-t-0 tw-border-solid tw-border-border-grey tw-p-4 last:tw-border-b-0"
          >
            <span className="tw-text-sm tw-font-medium">
              {plusOnes.length > 1 && `Guest ${index + 1}: `}
              {plusOne.firstName} {plusOne.lastName}
            </span>
            {isTargetStatusWaitlisted ? (
              <Badge variant="purple">Waitlisted</Badge>
            ) : (
              <Badge variant="destructive">Removed</Badge>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
